import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import { postRequest } from '../../requestUtils';
import ModalTrigger from '../common/ModalTrigger';
import DropdownIndicator from '../common/DropdownIndicator';
import dropdownStyleUtils from '../../dropdownStyleUtils';
import copyLinkImg from '../../../assets/images/link-green.svg';
import './ShareResource.scss';

class ShareResource extends Component {
  static handleFocus(event) {
    event.target.select();
  }

  constructor(props) {
    super(props);
    this.state = {
      errors: '',
      recipient: props.recipientOptions[0],
      skipScreening: false,
      copying: false,
      url: '',
      source: '',
    };

    this.handleToggleScreening = this.handleToggleScreening.bind(this);
    this.handleGenerate = this.handleGenerate.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
  }

  handleGenerate(callback) {
    const { generateUrl, csrfToken, resourceId } = this.props;
    const { source, recipient, skipScreening } = this.state;

    const linkType = recipient.value === 'employers' ? 'employer'
      : `consultant_${skipScreening ? 'sourced' : 'plain'}`;
    const data = { resource_id: resourceId, candidate_source: source.value, link_type: linkType };
    return postRequest(
      generateUrl,
      data,
      csrfToken,
    ).then((response) => {
      this.setState({
        url: response.data.url,
        errors: '',
      }, callback);
    }).catch((err) => {
      this.setState({ errors: err });
    });
  }

  handleToggleScreening(e) {
    const { skipScreening } = this.state;
    e.preventDefault();

    this.setState({ skipScreening: !skipScreening }, this.getUrl);
  }

  linkIsDisabled() {
    const { recipient, source } = this.state;

    return !(recipient.value === 'employers' || (recipient && source));
  }

  handleCopy() {
    const { url } = this.state;

    this.setState({ copying: true });
    copy(url);

    setTimeout(() => {
      this.setState({ copying: false });
    }, 1000);
  }

  render() {
    const {
      triggerType,
      triggerText,
      submitButtonText,
      idKey,
      resourceType,
      buttonStyles,
      sourceOptions,
      recipientOptions,
    } = this.props;
    const {
      source, skipScreening, copying, recipient,
    } = this.state;

    return (
      <ModalTrigger
        triggerType={triggerType}
        triggerText={triggerText}
        buttonStyles={buttonStyles}
        submitButtonText={submitButtonText}
        showFooter={false}
        idKey={idKey}
        dialogClassName="share-resource-modal"
      >
        <div className="share-resource-modal-body style-guide">
          <h2 className="mb-3">
            Choose the right options to get a shareable link.
          </h2>
          <div className="rep-choices mb-3">
            <div className="body-text-2">
              Who receives this link?
            </div>
            <Select
              classNamePrefix="recipient-type"
              options={recipientOptions}
              value={recipient || recipientOptions[0]}
              onChange={(newSelection) => this.setState({ recipient: newSelection }, this.getUrl)}
              styles={{ ...dropdownStyleUtils }}
              components={{ DropdownIndicator, IndicatorSeparator: () => null }}
            />
          </div>
          { recipient.value === 'consultant' && [
            <div className="rep-choices mb-3">
              <div className="body-text-2">
                How did you find the candidate(s)?
              </div>
              <Select
                classNamePrefix="sources-dropdown"
                options={sourceOptions}
                placeholder="Select source"
                value={source}
                onChange={(newSelection) => this.setState({ source: newSelection })}
                styles={{ ...dropdownStyleUtils }}
                components={{ DropdownIndicator, IndicatorSeparator: () => null }}
              />
            </div>,
            <div className="rep-choices mb-3">
              <div className="body-text-2">
                Do you want to skip application screening?
              </div>
              <label
                htmlFor="skip-application"
                className="custom-checkbox-container body-text-2"
                onClick={this.handleToggleScreening}
              >
                <input
                  type="checkbox"
                  id="agree-checkbox"
                  checked={skipScreening}
                />
                <span className="checkmark" />
                <span className="skip-application-label">
                  Yes, skip application screening.
                  I only want proposals from the consultant(s) who get this link.
                </span>
              </label>
            </div>,
          ]}
          <div className="copy-buttons-footer centered">
            <Button
              className={`copy-link ${copying ? 'transparent' : ''} copy-link-share`}
              disabled={this.linkIsDisabled()}
              id={`copy-link-share-${resourceType.toLowerCase()}`}
              onClick={() => this.handleGenerate(this.handleCopy)}
            >
              <div className="link-image">
                <img src={copyLinkImg} alt="Copy Share Link" />
              </div>
              <div className="link-text">
                Copy link
              </div>
            </Button>
          </div>
        </div>
      </ModalTrigger>
    );
  }
}

ShareResource.propTypes = {
  triggerText: PropTypes.string,
  submitButtonText: PropTypes.string,
  idKey: PropTypes.string,
  resourceType: PropTypes.string,
  buttonStyles: PropTypes.string,
  triggerType: PropTypes.string,
  sourceOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  recipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  generateUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
};

ShareResource.defaultProps = {
  triggerType: 'button',
  triggerText: 'Share Resource',
  submitButtonText: 'Generate Link',
  idKey: '',
  resourceType: 'project',
  buttonStyles: 'default',
};

export default ShareResource;
